<template>
  <div id="mainPage">
    <header>
      <Header />
    </header>
    <div id="main" :class="{ background10sen: is10sen }">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide"
            v-for="winner in virtualData.slides"
            :key="winner.id"
            :style="slideStyles"
          >
            
            <section class="artwork">
              <div class="inner2" v-if="winner.awardType !== 99 && winner.awardType !== EnumAwardTypeSpecialExhibitons">
                <!-- JTG -->
                <h1 v-if="winner.awardType == EnumAwardTypeJtg" class="photographer" >Japan Travel Gallery Photo Contest 2022<br>
                  <span class="titleSub">&nbsp;</span>
                  <br>
                  <strong>{{winner.name}}</strong>
                  <br>
                </h1>
                <!-- Weibo -->
                <h1 v-else-if="winner.awardType == EnumAwardTypeWeibo" class="photographer" >Weibo<br>
                  <span class="titleSub">&nbsp;</span>
                  <br>
                  <strong>{{winner.name}}</strong>
                  <br>
                </h1>
                <!-- 100景 -->
                <h1 v-else-if="winner.awardType == EnumAwardTypeJapan100Views" class="photographer" >日本写真100景＜四季＞2022<br>
                  <span class="titleSub">100 Cultural &amp; Landscape Photos of Japan</span>
                  <br>
                  <strong class="wrap">{{winner.name}}</strong>
                  <br>
                </h1>
                <!-- 「城と月」特別部門 -->
                <h1 v-else-if="winner.awardType == EnumAwardTypeCastleAndMoon" class="photographer" >「城と月」特別部門<br>
                  <span class="titleSub">&nbsp;</span>
                  <br>
                  <strong class="wrap">{{winner.name}}</strong>
                  <br>
                </h1>
                <!-- Twitter -->
                <h1 v-else-if="winner.awardType == EnumAwardTypeTwitter" class="photographer" style="word-break: keep-all;">「ご当地グルメ」on Twitter<br>
                  <span class="titleSub">&nbsp;</span>
                  <br>
                  <strong>{{winner.name}}</strong>
                  <br>
                </h1>
                <!-- Instagram -->
                <h1 v-else-if="winner.awardType == EnumAwardTypeInstagram" class="photographer" style="word-break: keep-all;">Instagram部門（３×３）<br>
                  <span class="titleSub">&nbsp;</span>
                  <br>
                  <strong>{{winner.name}}</strong>
                  <br>
                </h1>
                <!-- Monogatary -->
                <h1 v-else-if="winner.awardType == EnumAwardTypeMonogatary" class="photographer" style="word-break: keep-all;">Monogatary.com<br>
                  <span class="titleSub">&nbsp;</span>
                  <br>
                  <strong>{{winner.name}}</strong>
                  <br>
                </h1>
                <!-- 10選・その他 -->
                <h1 v-else class="photographer" >{{awardTypeNames[winner.awardType]}}<br>
                  <span class="titleSub">The 10 Photographers of {{get10SenYear(winner.id)}}</span>
                  <br>
                  <strong>{{winner.name}}</strong>
                  <br>
                </h1>
                <p class="nameSub">
                  <span v-if="winner.nameOption1">{{winner.nameOption1}}</span><br>
                  <span v-if="winner.nameOption2">{{winner.nameOption2}}</span>
                </p>
              </div>

              <!-- 協賛展示用開始 -->
              <div v-else-if="winner.awardType === EnumAwardTypeSpecialExhibitons" class="inner2">
                <div class="client"><p class="clientTitle">{{awardTypeNames[winner.awardType]}}</p><p class="titleSub">Exhibitions by Sponsors</p></div>
                <div class="clientName">
                  <img class="clientLogo" v-if="winner.profileImageUrl" :src="winner.profileImageUrl" alt="" style="max-width: 300px;" />
                  <h1 class="cNameTxt">{{winner.name}}</h1>
                </div>
              </div><!-- /inner2-->
              <!-- 協賛展示用終了 -->

              <template v-if="winner.isDisplayed">
                <div v-if="winner && winner.winnerIntroduction && (winner.winnerIntroduction.comment || winner.winnerIntroduction.youtubeUrl) && winner.awardType !== EnumAwardTypeSpecialExhibitons" class="exhCommentary">
                  <div style="overflow: auto;">
                  <div class="exhCommentaryBody openCloseAnimation" :class="{ hideCommentary: isWinnerIntroductionClose[winner.id] }" :style="{ marginTop: (- winner.minusMargin) + 'px' }" :id="'openClose-' + winner.id">
                    <div class="inner2">
                      <div v-if="isCommentExists(winner)" class="expTxt">
                        <p>{{winner.winnerIntroduction.comment}}</p>
                      </div>
                      <div class="expMovieArea">
                        <div v-if="isMovieExists(winner)" class="expMovie">
                          <iframe width="320" height="180" :src="convertYoutubeUrl(winner.winnerIntroduction.youtubeUrl)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      </div>

                    </div><!-- /inner-->
                  </div><!-- /exhCommentaryBody-->
                  </div>
                </div><!-- /exhCommentary-->
              </template>

              <!-- 協賛展示用開始 -->
              <div v-if="winner && winner.winnerIntroduction && (winner.winnerIntroduction.comment || winner.winnerIntroduction.youtubeUrl) && winner.awardType === EnumAwardTypeSpecialExhibitons" class="exhCommentary">
                <div class="exhCommentaryBody" style="overflow: auto;">
                  <div class="inner2" >
                    <div v-if="winner && winner.winnerIntroduction && winner.winnerIntroduction.comment" class="expTxt">
                      <p :class="{zeroPaddingRight: !winner.winnerIntroduction.youtubeUrl}">{{winner.winnerIntroduction.comment}}</p>
                    </div>
                    <div class="expMovieArea">
                      <div v-if="isMovieExists(winner)" class="expMovie">
                        <iframe width="320" height="180" :src="convertYoutubeUrl(winner.winnerIntroduction.youtubeUrl)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </div>
                    </div>
                  </div><!-- /inner-->
                </div><!-- /exhCommentaryBody-->
              </div><!-- /exhCommentary-->
              <!-- 協賛展示用終了 -->

              <template v-if="winner.isDisplayed">
                <PhotoWall202101      v-if="winner.id === 202101" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202102 v-else-if="winner.id === 202102" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202103 v-else-if="winner.id === 202103" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202104 v-else-if="winner.id === 202104" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202105 v-else-if="winner.id === 202105" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202106 v-else-if="winner.id === 202106" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202107 v-else-if="winner.id === 202107" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202108 v-else-if="winner.id === 202108" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202109 v-else-if="winner.id === 202109" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202110 v-else-if="winner.id === 202110" :winner="winner" :openImageViewer="openImageViewer" />

                <PhotoWall202001 v-else-if="winner.id === 202001" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202002 v-else-if="winner.id === 202002" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202003 v-else-if="winner.id === 202003" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202004 v-else-if="winner.id === 202004" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202005 v-else-if="winner.id === 202005" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202006 v-else-if="winner.id === 202006" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202007 v-else-if="winner.id === 202007" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202008 v-else-if="winner.id === 202008" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWall202009 v-else-if="winner.id === 202009" :winner="winner" :openImageViewer="openImageViewer" />
              </template>
              <PhotoWall10Sen v-if="winner.awardType == EnumAwardTypeTcc10Sen2019" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall10Sen1Work v-if="winner.awardType >= EnumAwardTypeTcc10Sen2018 && winner.awardType <= EnumAwardTypeTcc10Sen2012" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall100Kei v-else-if="winner.awardType == EnumAwardTypeJapan100Views" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWallCastleAndMoon v-else-if="winner.awardType == EnumAwardTypeCastleAndMoon" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWallTwitter v-else-if="winner.awardType == EnumAwardTypeTwitter" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWallTcc v-else-if="winner.awardType == EnumAwardTypeTcc" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWallInstagram v-else-if="winner.awardType == EnumAwardTypeInstagram" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWallJtg v-else-if="winner.awardType == EnumAwardTypeJtg" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWallWeibo v-else-if="winner.awardType == EnumAwardTypeWeibo" :winner="winner" :openImageViewer="openImageViewer" />
              <template v-if="winner.isDisplayed">
                <PhotoWallMonogatary v-if="winner.awardType == EnumAwardTypeSpecialExhibitons && winner.id === 600001" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWallTAndD v-else-if="winner.awardType == EnumAwardTypeSpecialExhibitons && winner.id === 600004" :winner="winner" :openImageViewer="openImageViewer" />
                <PhotoWallSpecial v-else-if="winner.awardType == EnumAwardTypeSpecialExhibitons" :winner="winner" :openImageViewer="openImageViewer" />
              </template>
              <PhotoWallSpacer v-if="winner.awardType == spacerAwardTypeId" :winner="winner" />
            </section>

            <template v-if="winner.isDisplayed">
              <template v-if="winner && winner.awardType !== EnumAwardTypeSpecialExhibitons">
                <section v-if="isProfileExists(winner)" class="profile">
                  <div class="inner2 clearfix">
                    <div v-if="winner.profileImageUrl" class="left"><img class="profImg" :src="winner.profileImageUrl" alt=""/></div>
                    <div class="right">
                          <h3 class="profName" style="word-break: break-all;;">{{winner.name}}</h3><h4 v-if="winner.nameOption1" class="profNameSub">{{winner.nameOption1}}</h4>
                        <p v-if="winner.profileStatement" class="profTxt">
                          <span style="white-space: pre-wrap;">{{winner.profileStatement}}</span>
                        </p>
                        <!-- プロフィールリンクを出力 -->
                        <div class="profLink">
                          <p v-if="winner.winnerIntroduction && winner.winnerIntroduction.link1Url" class="relatedLink">
                            <a v-on:click="externalLinkConfirm" :href="winner.winnerIntroduction.link1Url" target="_blank" rel="noopener noreferrer">{{winner.winnerIntroduction.link1Text ? winner.winnerIntroduction.link1Text : winner.winnerIntroduction.link1Url}}</a>
                          </p>
                          <p v-if="winner.winnerIntroduction && winner.winnerIntroduction.link2Url" class="relatedLink">
                            <a v-on:click="externalLinkConfirm" :href="winner.winnerIntroduction.link2Url" target="_blank" rel="noopener noreferrer">{{winner.winnerIntroduction.link2Text ? winner.winnerIntroduction.link2Text : winner.winnerIntroduction.link2Url}}</a>
                          </p>
                          <p v-if="winner.winnerIntroduction && winner.winnerIntroduction.link3Url" class="relatedLink">
                            <a v-on:click="externalLinkConfirm" :href="winner.winnerIntroduction.link3Url" target="_blank" rel="noopener noreferrer">{{winner.winnerIntroduction.link3Text ? winner.winnerIntroduction.link3Text : winner.winnerIntroduction.link3Url}}</a>
                          </p>
                        </div>
                    </div>
                  </div><!-- /inner-->
                </section><!-- /profile-->
              </template>
            </template>

            <!-- 協賛展示用開始 -->
            <template v-if="isRelatedInfo(winner)">
              <section class="relatedInfo">
                <div class="inner2">
                  <h3>関連情報</h3>
                  <div class="relatedfTxt">
                    <span v-html="winner.profileStatement"></span>
                  </div>
                  <p v-if="winner.winnerIntroduction && winner.winnerIntroduction.link1Url" class="relatedLink">
                    <a v-on:click="externalLinkConfirmSpecial" :href="winner.winnerIntroduction.link1Url" target="_blank" rel="noopener noreferrer">{{winner.winnerIntroduction.link1Text}}</a>
                  </p>
                  <p v-if="winner.winnerIntroduction && winner.winnerIntroduction.link2Url" class="relatedLink">
                    <a v-on:click="externalLinkConfirmSpecial" :href="winner.winnerIntroduction.link2Url" target="_blank" rel="noopener noreferrer">{{winner.winnerIntroduction.link2Text}}</a>
                  </p>
                  <p v-if="winner.winnerIntroduction && winner.winnerIntroduction.link3Url" class="relatedLink">
                    <a v-on:click="externalLinkConfirmSpecial" :href="winner.winnerIntroduction.link3Url" target="_blank" rel="noopener noreferrer">{{winner.winnerIntroduction.link3Text}}</a>
                  </p>
                </div><!-- /inner-->
              </section><!-- /message-->
            </template>
            <!-- 協賛展示用終了 -->

            <section v-if="winner.awardType == EnumAwardTypeJapan100Views && !isDemo()" class="photospotArea">
                <div class="inner2">
                  <div class="photospotBanner">
                    <a :href="linkUrl100Kei + winner.winningWorks[0].sheetaWorkId + '&utm_source=tokyocameraclub&utm_medium=banner&utm_campaign=exh2022'" target="_blank">
                      <img src="/img/photospot_banner.png">
                    </a>
                  </div>
                </div><!-- /inner-->
            </section><!-- /photospotArea-->

          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.path.indexOf('/sponsors') == -1 || !isDemo()" class="cursorRight" :class="{ cursorDisable: this.currentIndex == (this.winners.length - 1) }">
      <a href="javascript:void(0);" @click="moveNext" :class="{ cursorDisable: this.currentIndex == (this.winners.length - 1) }">
        <img src="/img/arwRight.png" srcset="/img/arwRight@2x.png" style="filter: blur(0px)" />
      </a>
    </div>
    <div v-if="$route.path.indexOf('/sponsors') == -1 || !isDemo()" class="cursorLeft" :class="{ cursorDisable: this.currentIndex == 0 }">
      <a href="javascript:void(0);" @click="movePrev" :class="{ cursorDisable: this.currentIndex == 0 }">
        <img src="/img/arwLeft.png" srcset="/img/arwLeft@2x.png" style="filter: blur(0px)" />
      </a>
    </div>
    <MessageDialog :isOpen.sync="isMessageOpen" :title="messageTitle" :text="messageText" />
    <Footer />
    <ImageViewer
      :isOpen.sync="isImageViewerOpen"
      :winner="currentWinner"
      :winningWork="currentWinningWork"
      :commentaryType="commentaryType"
      ref="imageViewer"
    />
    <PortfolioViewer
      :isOpen.sync="isPortfolioViewerOpen"
      :winner="currentWinner"
      ref="portfolioViewer"
    />
    <div class="actionMenu" :class="{ addRightMargin: isImageOrPortfolio, portfolioLayout: isPortfolioViewerOpen }">
      <PortfolioButton v-if="currentWinner && currentWinner.portfolios && currentWinner.portfolios[0] && currentWinner.portfolios[0].portfolioWorks && currentWinner.portfolios[0].portfolioWorks.length && !isPortfolioViewerOpen" :winner="currentWinner" :open="openPortfolioViewer" />
      <MessageButton v-if="!isDemo() || currentWinner.awardType != 16" :winner="currentWinner" :open="openMessageDrawer" />
      <UpButton v-if="!isPortfolioViewerOpen && !isImageViewerOpen" />
    </div>

    <ExternalSiteAlertDialog
      :isOpen.sync="isExternalSiteAlertOpen"
      :link="externalSiteLink"
      :isSpecial="isSpecial"
    ></ExternalSiteAlertDialog>

    <MessageDrawer
      :winner="currentWinner"
      :isOpen="isOpenMessageDrawer"
      :close="closeMessageDrawer"
      :goReference="goReference"
    ></MessageDrawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import ImageViewer from '@/components/modules/ImageViewer.vue'
import PortfolioViewer from '@/components/modules/PortfolioViewer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import Swiper from 'swiper/bundle'
import MessageDialog from '@/components/modules/MessageDialog.vue'
import sanitizeHtml from 'sanitize-html'
import AutoLinkUtil from '@/util/AutoLinkUtil'
import PhotoWall202101 from '@/components/modules/photoWall/PhotoWall202101.vue'
import PhotoWall202102 from '@/components/modules/photoWall/PhotoWall202102.vue'
import PhotoWall202103 from '@/components/modules/photoWall/PhotoWall202103.vue'
import PhotoWall202104 from '@/components/modules/photoWall/PhotoWall202104.vue'
import PhotoWall202105 from '@/components/modules/photoWall/PhotoWall202105.vue'
import PhotoWall202106 from '@/components/modules/photoWall/PhotoWall202106.vue'
import PhotoWall202107 from '@/components/modules/photoWall/PhotoWall202107.vue'
import PhotoWall202108 from '@/components/modules/photoWall/PhotoWall202108.vue'
import PhotoWall202109 from '@/components/modules/photoWall/PhotoWall202109.vue'
import PhotoWall202110 from '@/components/modules/photoWall/PhotoWall202110.vue'
import PhotoWall202001 from '@/components/modules/photoWall/PhotoWall202001.vue'
import PhotoWall202002 from '@/components/modules/photoWall/PhotoWall202002.vue'
import PhotoWall202003 from '@/components/modules/photoWall/PhotoWall202003.vue'
import PhotoWall202004 from '@/components/modules/photoWall/PhotoWall202004.vue'
import PhotoWall202005 from '@/components/modules/photoWall/PhotoWall202005.vue'
import PhotoWall202006 from '@/components/modules/photoWall/PhotoWall202006.vue'
import PhotoWall202007 from '@/components/modules/photoWall/PhotoWall202007.vue'
import PhotoWall202008 from '@/components/modules/photoWall/PhotoWall202008.vue'
import PhotoWall202009 from '@/components/modules/photoWall/PhotoWall202009.vue'
import PhotoWall10Sen from '@/components/modules/photoWall/PhotoWall10Sen.vue'
import PhotoWall10Sen1Work from '@/components/modules/photoWall/PhotoWall10Sen1Work.vue'
import PhotoWall100Kei from '@/components/modules/photoWall/PhotoWall100Kei.vue'
import PhotoWallTwitter from '@/components/modules/photoWall/PhotoWallTwitter.vue'
import PhotoWallTcc from '@/components/modules/photoWall/PhotoWallTcc.vue'
import PhotoWallCastleAndMoon from '@/components/modules/photoWall/PhotoWallCastleAndMoon.vue'
import PhotoWallInstagram from '@/components/modules/photoWall/PhotoWallInstagram.vue'
import PhotoWallJtg from '@/components/modules/photoWall/PhotoWallJtg.vue'
import PhotoWallWeibo from '@/components/modules/photoWall/PhotoWallWeibo.vue'
import PhotoWallMonogatary from '@/components/modules/photoWall/PhotoWallMonogatary.vue'
import PhotoWallTAndD from '@/components/modules/photoWall/PhotoWallTAndD.vue'
import PhotoWallSpecial from '@/components/modules/photoWall/PhotoWallSpecial.vue'
import PhotoWallSpacer from '@/components/modules/photoWall/PhotoWallSpacer.vue'
import UpButton from '@/components/modules/UpButton.vue'
import MessageButton from '@/components/modules/MessageButton.vue'
import MessageDrawer from '@/components/modules/MessageDrawer.vue'
import PortfolioButton from '@/components/modules/PortfolioButton.vue'
import YoutubeUtil from '@/util/YoutubeUtil'
import { WinnersApi } from '../../api'
import ExternalSiteAlertDialog from '@/components/modules/ExternalSiteAlertDialog.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    ImageViewer,
    PortfolioViewer,
    MessageDialog,
    PhotoWall202101,
    PhotoWall202102,
    PhotoWall202103,
    PhotoWall202104,
    PhotoWall202105,
    PhotoWall202106,
    PhotoWall202107,
    PhotoWall202108,
    PhotoWall202109,
    PhotoWall202110,
    PhotoWall202001,
    PhotoWall202002,
    PhotoWall202003,
    PhotoWall202004,
    PhotoWall202005,
    PhotoWall202006,
    PhotoWall202007,
    PhotoWall202008,
    PhotoWall202009,
    PhotoWall10Sen,
    PhotoWall10Sen1Work,
    PhotoWall100Kei,
    PhotoWallCastleAndMoon,
    PhotoWallTwitter,
    PhotoWallTcc,
    PhotoWallInstagram,
    PhotoWallJtg,
    PhotoWallWeibo,
    PhotoWallSpecial,
    PhotoWallMonogatary,
    PhotoWallTAndD,
    PhotoWallSpacer,
    UpButton,
    MessageButton,
    PortfolioButton,
    ExternalSiteAlertDialog,
    MessageDrawer
  },
  data () {
    return {
      unsubscribe: null,
      swiper: null,
      isTest: false,
      isImageViewerOpen: false,
      commentaryType: '',
      isPortfolioViewerOpen: false,
      currentIndex: 0,
      currentWinner: { id: null },
      currentWinningWork: null,
      slides: [],
      virtualData: {
        slides: []
      },
      isWinnerIntroductionClose: {},
      isMessageOpen: false,
      messageTitle: '',
      messageText: '',
      currentScrollPosition: 0,
      isCursorUpOn: false,
      is10sen: false,
      isExternalSiteAlertOpen: false, // 外部サイトリンク警告ダイアログ表示制御フラグ
      externalSiteLink: null, // 外部サイトリンク
      isSpecial: false, //特別展示か
      isImageOrPortfolio: false, // 現在が画像詳細画面かポートフォリオ画面の時true
      // メッセージ機能関連
      isOpenMessageDrawer: false,
      // カーソル
      isRightDisabled: false,
      isLeftDisabled: false
    }
  },
  methods: {
    ...mapActions([
      'setWinners',
      'updateWinners'
    ]),
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    openMessageDrawer () {
      if (this.isDemo()) {
        alert('メッセージ機能は現在使用できません。\r\n写真展サイト正式公開後に使用可能となります。')
      } else {
        // 画面幅が640px以下の場合は、背景は固定する
        const mediaQuery = window.matchMedia('(max-width: 640px)')
        if (mediaQuery) {
          this.bodyFixedOn()
        }
        this.isOpenMessageDrawer = true
      }
    },
    closeMessageDrawer () {
      this.isOpenMessageDrawer = false
    },
    setTitleAndDescription (to) {
      const winner = this.winnersById(to.params.id)
      if (!winner) return

      // titleの設定
      let pageTitle = ''
      if (to.params.winningWorkId) {
        // 作品画像詳細の場合
        const winningWork = this.winningWorkById(to.params.winningWorkId)
        if (!winningWork) return
        pageTitle = `${this.awardTypeNames[winner.awardType]} ${winner.name}「${winningWork.title}」`
      } else if (to.params.portfolioId) {
        // ポートフォリオの場合
        pageTitle = `${winner.name}`
      } else {
        // 出展者の場合
        pageTitle = `${this.awardTypeNames[winner.awardType]} ${winner.name}`
      }
      document.title = pageTitle + (to.meta.title ? to.meta.title : '')
      // descriptionの設定
      const pageDescription = ''
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : '') + pageDescription)
    },
    // イメージビュワー表示
    openImageViewer (winningWork, commentaryType = null) {
      // モーダルダイアログを表示する際にはメインページ（背景ページ）のスクロールを固定する
      this.bodyFixedOn()

      this.currentWinner = this.winnersById(winningWork.winnerId)
      this.currentWinningWork = winningWork
      this.commentaryType = commentaryType
      this.isImageViewerOpen = true

      // 個別画像ページへURL書き換え
      const path = `${this.createWinnerUrl(this.currentWinner)}/images/${winningWork.id}`
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
    },
    // メインページスクロール固定処理設定
    bodyFixedOn () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        this.currentScrollPosition = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.currentScrollPosition}px`
      } else {
        body.style.overflow = 'hidden'
      }
    },
    // メインページスクロール固定処理解除
    bodyFixedOff () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        body.style.removeProperty('position')
        body.style.removeProperty('top')
        window.scrollTo(0, this.currentScrollPosition)
      } else {
        body.style.removeProperty('overflow')
      }
    },
    // ポートフォリオビュワー表示
    openPortfolioViewer (winner) {
      if (!winner.portfolios || winner.portfolios.length <= 0) {
        return // ポートフォリオが存在しない場合、処理終了
      }

      if (this.isImageViewerOpen) { // すでに画像を開いていた場合一度閉じて、遅延して表示
        this.$refs.imageViewer.close()
      }

      // モーダルダイアログを表示する際にはメインページ（背景ページ）のスクロールを固定する
      this.bodyFixedOn()

      this.currentWinner = winner
      this.isPortfolioViewerOpen = true

      // ポートフォリオページへURL書き換え
      const path = `${this.createWinnerUrl(this.currentWinner)}/portfolios/${winner.portfolios[0].id}${this.$route.params && this.$route.params.index ? '/' + this.$route.params.index : ''}`
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
    },
    // スワイプ移動イベント
    async slideChange (event) {
      this.closeMessageDrawer() // swiperした場合は、メッセージドロワーは閉じる

      const preIndex = this.currentIndex
      this.currentIndex = event.activeIndex
      this.currentWinner = this.winners[event.activeIndex]
      // winnerIntroductionがwinnerに含まれていない場合はここで取得
      if (!this.currentWinner.winnerIntroduction) {
        await WinnersApi.getWinner(this.currentWinner.id).then((result) => {
          // 表示内容に追加
          const newWinner = { ...this.currentWinner, ...result }
          this.currentWinner = newWinner
        })
      }

      // 空白ページ判定
      // 空白ページだった場合、カテゴリの最初であれば、最後に、最後であれば、最初にジャンプする
      if (this.currentWinner.awardType === this.spacerAwardTypeId) {
        const index = this.getJumpIndex(preIndex)
        const path = this.createArtworksWinnerUrl(index)
        if (this.$route.path == path) { // 空白ページから戻る先が同じURLパスだった場合indexのみの更新とする
          this.moveSlideByUrl()
        } else {
          this.$router.push(path) // URLパスが違う場合、街頭の最初もしくは最後のURLパスにジャンプ
        }
      } else {
        // 通常ページの場合の処理
        // パス生成
        const path = this.createArtworksWinnerUrl(event.activeIndex)
        // 移動先のパスが現在と違う場合書き換え
        // ただし、個別画像画面では無い（winningWorkIdパラメータで詳細画面が指定されていない）
        // かつ、ポートフォリオ画面では無い（portfolioIdパラメータでポートフォリオが指定されていない）
        // の条件を満たしている必要がある
        if (path != '' && path !== this.$route.path && (!this.$route.params.winningWorkId && !this.$route.params.portfolioId)) {
          this.$router.push(path)
        }
      }

      // コメントがあればloadする
      if (this.$refs['comment' + this.currentWinner.id] && this.$refs['comment' + this.currentWinner.id][0]) {
        this.$refs['comment' + this.currentWinner.id][0].load()
      }
    },
    // 指定されたindexから飛び先のindexを取得
    getJumpIndex (index) {
      const sourceWinner = this.winners[index]
      let minIdIndex = null
      let maxIdIndex = null
      for (let i = 0; i < this.winners.length; i++) {
        const winner = this.winners[i]
        // swipeでスライドできる範囲のまとめを設定する
        // 対象受賞カテゴリのindexの最小と最大を求める
        // 10選は一まとまりにするため、awardTypeSwipeCategoryを使ってチェック
        const sourceAwardTypeCode = this.awardTypeSwipeCategory[sourceWinner.awardType]
        const code = this.awardTypeSwipeCategory[winner.awardType]
        if (code === sourceAwardTypeCode) {
          if (minIdIndex === null) {
            minIdIndex = i
          }
          maxIdIndex = i
        }
      }
      if (minIdIndex >= index) {
        return maxIdIndex
      } else {
        return minIdIndex
      }
    },
    createWinnerUrl (winner) {
      let path = ''
      if (winner.awardType >= this.EnumAwardTypeTcc10Sen2021 && winner.awardType <= this.EnumAwardTypeTcc10Sen2012) {
        const year = 2022 - winner.awardType
        path = `/t10s/${year}/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeJapan100Views) {
        const areaNameJa = this.prefecturesMap[winner.mainImageTitle]
        const areaNameAlpha = this.areaAlphabetMap[areaNameJa]
        const prefNameAlpha = this.prefecturesAlphabetMap[winner.mainImageTitle]
        path = `/j100v/${areaNameAlpha}/${prefNameAlpha}/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeCastleAndMoon) {
        path = `/organizer/castleandmoon/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTwitter) {
        path = `/organizer/twitter/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeInstagram) {
        path = `/organizer/instagram/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeJtg) {
        path = `/organizer/jtg/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeWeibo) {
        path = `/organizer/weibo/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeMonogatary) {
        path = `/organizer/monogatary/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeSpecialExhibitons) {
        path = `/sponsors/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTcc) {
        path = `/tcc/umue37w3cepffokfglc6/${winner.id}`
      }
      return path
    },
    // index番号からURLを生成
    createArtworksWinnerUrl (index) {
      return this.createWinnerUrl(this.winners[index])
    },
    // URLから特定のslideを表示するメソッド
    moveSlideByUrl () {
      // スライド移動
      if (this.winnersIndexById(this.$route.params.id) !== this.swiper.activeIndex) {
        setTimeout(() => {
          this.swiper.slideTo(this.winnersIndexById(this.$route.params.id), 500, false)
          this.currentIndex = this.winnersIndexById(this.$route.params.id)
          this.currentWinner = this.winners[this.currentIndex]
          if (this.currentWinner && this.$refs['comment' + this.currentWinner.id] && this.$refs['comment' + this.currentWinner.id][0]) {
            this.$refs['comment' + this.currentWinner.id][0].load()
          }
        }, 300)
      }
    },
    // 右へswipe
    moveNext () {
      if (this.isRightDisabled) return
      this.isRightDisabled = true;
      setTimeout(() => {
        this.isRightDisabled = false;
      }, 300)
      if (this.currentIndex >= this.winners.length) {
        return
      }
      this.swiper.slideTo(this.currentIndex + 1, 500, false)
    },
    // 左へswipe
    movePrev () {
      if (this.isLeftDisabled) return
      this.isLeftDisabled = true;
      setTimeout(() => {
        this.isLeftDisabled = false;
      }, 300)
      if (this.currentIndex <= 0) {
        return
      }
      this.swiper.slideTo(this.currentIndex - 1, 500, false)
    },
    changeCommentaryMode (value) {
      const el = document.getElementById('openClose-' + this.currentWinner.id)
      if (value) {
        this.currentWinner.minusMargin = el.clientHeight
      } else {
        this.currentWinner.minusMargin = 0
      }
      this.$set(this.isWinnerIntroductionClose, this.currentWinner.id, value)
    },
    // 応援メッセージからの参照元リンククリック時の挙動
    goReference (displayLinkUrl) {
      const url = new URL(displayLinkUrl)
      const path = url.pathname

      if (path.indexOf('/images/') > 0) {
        // 画像詳細を表示
        this.openImageViewerFromMessageDrawer(path)
      } else if (url.pathname.indexOf('/portfolios/') > 0) {
        // ポートフォリを表示
        this.openPortfolioViewerFromMessageDrawer(path)
      } else {
        // 作品ページを表示
        this.openArtworksFromMessageDrawer()
      }

      // スマホの場合はメッセージドロワーを閉じる
      const mediaQuery = window.matchMedia('(max-width: 640px)')
      if (mediaQuery.matches) {
        this.closeMessageDrawer()
      }
    },
    // メッセージドロワーから画像詳細を開く処理
    openImageViewerFromMessageDrawer (path) {
      // 詳細画像を対象にメッセージが書かれていた場合
      // 表示すべきwinningWorkを取得
      const targetWinningWork = this.getTargetWinningWorkFromPath(path)
      if (!targetWinningWork) return // なければ終了
      if (this.isImageViewerOpen) { // すでに画像を開いていた場合一度閉じて、遅延して表示
        this.$refs.imageViewer.close()
        setTimeout(() => {
          this.openImageViewer(targetWinningWork) // 対象画像を遅延表示
        }, 300)
      } else if (this.isPortfolioViewerOpen) { // すでに、ポートフォリオを開いていた場合一度閉じて、遅延して表示
        this.$refs.portfolioViewer.close()
        setTimeout(() => {
          this.openImageViewer(targetWinningWork) // 対象画像を遅延表示
        }, 300)
      } else {
        this.openImageViewer(targetWinningWork) // 何も開いていない場合、対象画像を普通に表示
      }
    },
    // メッセージドロワーからポートフォリオを開く処理
    openPortfolioViewerFromMessageDrawer (path) {
      if (this.isImageViewerOpen) { // すでに画像を開いていた場合一度閉じて、遅延して表示
        this.$refs.imageViewer.close()
        setTimeout(() => {
          this.$router.push(path)
          this.openPortfolioViewer(this.currentWinner) // ポートフォリオを遅延表示
        }, 300)
      } else if (this.isPortfolioViewerOpen) { // すでに、ポートフォリオを開いていた場合一度閉じて、遅延して表示
        this.$refs.portfolioViewer.close()
        setTimeout(() => {
          this.$router.push(path)
          this.openPortfolioViewer(this.currentWinner) // ポートフォリオを遅延表示
        }, 300)
      } else {
        this.$router.push(path)
        this.openPortfolioViewer(this.currentWinner)
      }
    },
    openArtworksFromMessageDrawer () {
      if (this.isImageViewerOpen) { // すでに画像を開いていた場合、閉じる
        this.$refs.imageViewer.close()
      } else if (this.isPortfolioViewerOpen) { // すでに、ポートフォリオを開いていた場合、閉じる
        this.$refs.portfolioViewer.close()
      }
    },
    getTargetWinningWorkFromPath (path) {
      let targetWinningWork = null
      const imageMatch = path.match(/^\/(.+)\/images\/(\d+)$/)
      if (imageMatch && imageMatch.length > 2) {
        const winningWorkId = imageMatch[2]
        for (const winningWork of this.currentWinner.winningWorks) {
          if (winningWork.id == winningWorkId) {
            targetWinningWork = winningWork
            break
          }
        }
      }
      return targetWinningWork
    },
    get10SenYear (id) {
      if (!id) return ''
      return String(id).substring(0, 4)
    },
    sanitizeAndAutoLink (str) {
      return AutoLinkUtil.convert(sanitizeHtml(str, { allowedTags: [], allowedAttributes: {} }))
    },
    isCommentExists (winner) {
      return (
        winner && winner.winnerIntroduction &&
        winner.winnerIntroduction.comment
      )
    },
    isMovieExists (winner) {
      return (
        winner && winner.winnerIntroduction &&
        winner.winnerIntroduction.youtubeUrl
      )
    },
    convertYoutubeUrl (url) {
      return YoutubeUtil.getEmbedUrl(url)
    },
    getWinningWorkByPath (path) {
      const pathList = path.split('/')
      if (pathList && pathList.length >= 5) {
        return this.winningWorkById(pathList[5])
      }
      return null
    },
    isProfileExists (winner) {
      if (winner.awardType == this.EnumAwardTypeSpecialExhibitons) return false // 特別出展の場合は関連情報を表示するため、プロフィールは表示しない
      return (
        (winner && winner.profileImageUrl) ||
        (winner && winner.profileStatement) ||
        (winner && winner.winnerIntroduction && winner.winnerIntroduction.link1Url) ||
        (winner && winner.winnerIntroduction && winner.winnerIntroduction.link2Url) ||
        (winner && winner.winnerIntroduction && winner.winnerIntroduction.link3Url)
      )
    },
    get2xLogoUrl (logoUrl) {
      return logoUrl.replace('.jpg', '@2x.jpg 2x')
    },
    isRelatedInfo (winner) {
      if (winner.awardType != this.EnumAwardTypeSpecialExhibitons) return false // 特別出展の場合のみ関連情報を表示する
      return (
        (winner && winner.profileStatement) ||
        (winner && winner.winnerIntroduction && winner.winnerIntroduction.link1Url) ||
        (winner && winner.winnerIntroduction && winner.winnerIntroduction.link2Url) ||
        (winner && winner.winnerIntroduction && winner.winnerIntroduction.link3Url)
      )
    },
    // 外部リンク遷移時の警告ダイアログを表示
    externalLinkConfirm (e) {
      this.isSpecial = false
      this.isExternalSiteAlertOpen = true
      this.externalSiteLink = e.srcElement.href
      e.preventDefault() // リンク先へ遷移しないよう制御
      return
    },
    // 外部リンク遷移時の警告ダイアログを表示
    externalLinkConfirmSpecial (e) {
      this.isSpecial = true
      this.isExternalSiteAlertOpen = true
      this.externalSiteLink = e.srcElement.href
      e.preventDefault() // リンク先へ遷移しないよう制御
      return
    }

  },
  computed: {
    ...mapGetters([
      'winners',
      'winnersById',
      'winnersIndexById',
      'winnersByAwardType',
      'winningWorkById'
    ]),
    slideStyles () {
      return `left: ${this.virtualData.offset}px`
    }
  },
  created () {
  },
  mounted () {
    // swiper初期設定
    const self = this
    this.swiper = new Swiper('.swiper-container', {
      shortSwipes: false, // スワイプの反応状態 true の場合、ちょっとずらしただけでスワイプする
      noSwiping: true,
      noSwipingSelector: '.notSwipe,input,textarea,.msgPstArea' + (this.$route.path.indexOf('/sponsors') >= 0 && this.isDemo() ? ',body' : ''), // デモモード時、協賛展示はスワイプ禁止
      virtual: {
        slides: this.winners,
        renderExternalUpdate: true, // renderExternal実行直後にupdateするように設定
        renderExternal: async (data) => {
          const slides = []
          for (const winner of data.slides) {
            // 取得したデータにwinnerIntroductionが含まれない場合、ここで取得する
            if (winner.winnerIntroduction || winner.awardType === this.spacerAwardTypeId) {
              slides.push(winner)
            } else {
              await WinnersApi.getWinner(winner.id).then((result) => {
                // 表示内容に追加
                const newWinner = { ...winner, ...result }
                slides.push(newWinner)
                // store側も書き換え
                this.updateWinners(newWinner)
              })
            }
          }
          // スライドのデータは同時に3つ設定され、仮想的に3つのDOMが生成される
          // そのため、現在表示されている[1]のデータ以外に、bodyの長いデータがあった場合、
          // [1]のheightも、引きずられて、長くなってしまう。そのため、ここで、body部の表示を
          // 現在表示されている[1]のデータ以外は、非表示とし、自身が表示された場合のみ、
          // body部を表示するように調整している
          if (slides.length == 3) {
            slides[0].isDisplayed = false
            slides[1].isDisplayed = true
            slides[2].isDisplayed = false
          }
          data.slides = slides
          self.virtualData = data
        }
      },
      on: {
        slideChange: this.slideChange
      }
    })
    // winnersのvuexへの読み込み状態を監視し、読み込まれたら表示を更新する
    this.unsubscribe = this.$store.subscribe(async (mutation) => {
      if (mutation.type === 'setWinners') {
        // 一度だけ実行できればいい処理なので、最初で購読解除をする
        this.unsubscribe()

        // 現在位置情報を保持
        this.currentIndex = this.winnersIndexById(this.$route.params.id)
        this.currentWinner = this.winners[this.currentIndex]

        // 現在表示状態のwinnerについては個別で取得
        if (!this.currentWinner.winnerIntroduction) {
          await WinnersApi.getWinner(this.$route.params.id).then((result) => {
            // store側を書き換え
            const newWinner = { ...this.currentWinner, ...result }
            this.updateWinners(newWinner)
            this.currentWinner = newWinner
          })
        }

        // swiperに初期値設定
        this.swiper.virtual.appendSlide(this.winners)

        // またURLの指定された位置を検知しswiperを適切なindex番号に遷移させる
        setTimeout(() => {
          this.swiper.slideTo(this.winnersIndexById(this.$route.params.id), 0, false)
        }, 300)

        // 存在しないURLが指定されていた場合Not Foundに遷移
        // 読み込み完了までにタイムラグがあるため、setTimeoutで実行
        setTimeout(() => {
          // 出展者が存在しない場合
          if (!this.winnersById(this.$route.params.id)) {
            this.$router.push('/notFound')
          }
        }, 300)

        // 画像ビュワー表示判定
        // winningWorkIdが指定されているのにもかかわらず、画像個別ウインドウが表示されていなければ表示
        if (this.$route.params.winningWorkId && !this.isImageViewerOpen) {
          let winningWork = null
          for (const wWork of this.currentWinner.winningWorks) {
            if (String(wWork.id) === this.$route.params.winningWorkId) {
              winningWork = wWork
              break
            }
          }
          // 作品が存在しない場合
          if (this.$route.params.winningWorkId && !this.winningWorkById(this.$route.params.winningWorkId)) {
            this.bodyFixedOff()
            this.$router.push('/notFound')
            return
          }

          this.openImageViewer(winningWork)
        }

        // ポートフォリオ表示判定
        // portfolioIdが指定されているのにもかかわらず、ポートフォリオウインドウが表示されていなければ表示
        if (this.$route.params.portfolioId && !this.isPortfolioViewerOpen) {
          this.openPortfolioViewer(this.currentWinner)
        }

        // titleとdescriptionの設定
        this.setTitleAndDescription(this.$route)

        // 10選判定
        this.is10sen = (this.$route.path.indexOf('/t10s') >= 0)
      }

      this.moveSlideByUrl()
    })
    this.moveSlideByUrl()
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    // モーダルウインドウが閉じられたらメインページのスクロールができるようにする
    isImageViewerOpen: function (val) {
      if (!val) {
        this.bodyFixedOff()
      }
    },
    // モーダルウインドウが閉じられたらメインページのスクロールができるようにする
    isPortfolioViewerOpen: function (val) {
      if (!val) {
        this.bodyFixedOff()
      }
    },
    // メッセージドロワー表示時、iPhoneの場合のみメインページを固定するので、閉じられたらメインページのスクロールができるようにする
    isOpenMessageDrawer: function (val) {
      if (!val) {
        // メッセージドロワー表示時に背景画面が固定される場合があるため、ここで解除する
        // なお、解除時は画面幅が変更されている場合もあるので、常に解除処理を実行する
        this.bodyFixedOff()
      }
    },
    $route: function (to) {
      this.setTitleAndDescription(to)
    },
    '$route.path': function (val, oldVal) {
      this.moveSlideByUrl()

      // 10選判定
      this.is10sen = (this.$route.path.indexOf('/t10s') >= 0)

      // actionMenurRightMargin設定
      this.isImageOrPortfolio = (this.$route.path.indexOf('/images/') >= 0 || this.$route.path.indexOf('/portfolios/') >= 0)

      // 旧URLに /images/ が無く、新URLに /images/ があった場合（戻るボタンで戻ってきた場合）かつ未だウインドウがopenされてない場合、ウインドウをopen
      const index = val.indexOf('/images/')
      const oldIndex = oldVal.indexOf('/images/')
      if (oldIndex < 0 && index >= 0 && !this.isImageViewerOpen) {
        const winningWork = this.getWinningWorkByPath(this.$route.path)
        if (winningWork) {
          this.openImageViewer(winningWork) // 表示
        }
      }
    }
  }
}
</script>

<style scoped>
@import '~swiper/swiper-bundle.css';

.imgArtwork {
  width: 250px;
  height: 250px;
  object-fit: contain;
}

.cursorRight {
  width: 42px;
  height: 44px;
  position: fixed;
  right: 8px;
  top:calc(50% - 88px/2);
  z-index: 2000;
}

.cursorLeft {
  width: 42px;
  height: 44px;
  position: fixed;
  left: 8px;
  top:calc(50% - 88px/2);
  z-index: 2000;
}

.cursorDisable {
  opacity: 0.5;
  cursor: default;
}

.openCloseAnimation {
  margin-top: 0px;
  transition: all 1s;
  opacity: 1;
  margin-top: -5px;
}

.hideCommentary {
  /* margin-top: -600px; */
  opacity: 0;
}

@media screen and ( max-width:640px) {
  .cursorRight {
    width: 28px;
    height: 29px;
    right: 4px;
  }
  .cursorLeft {
    width: 28px;
    height: 29px;
    left: 4px;
  }
}

.zeroPaddingRight{
  padding-right: 0 !important;
}
</style>
